import * as PIXI from 'pixi.js'
import { IPopOutSpaceData, IPointZone } from 'js/bubbleCore/types';
import { Bubble } from 'js/bubbleCore/bubbles/types';
import { PointZoneView } from 'js/bubbleCore/view/entities/PointZoneView';
import { IHexPixelSize } from 'js/bubbleCore/view/types';
import { EventType, IEvent, IHasEventHandlers, EventHandlers } from 'js/bubbleCore/events';
import { PoolGroup } from 'framework/utils/PoolGroup';
import { Place } from 'js/bubbleCore/types';
import { TweenManager } from 'framework/TweenManager/TweenManager';

export class PointZonesView extends PIXI.Container implements IHasEventHandlers {
  public readonly eventHandlers: EventHandlers = {
    [EventType.BubbleUpdated]: (e) => {
      if (e.data.bubble.place !== Place.PopOutSpace) return;
      this.handleBubbleUpdate(e);
    },
    [EventType.BubblePointZoneCollision]: (e) => {
      const view = this.idToView.get(e.data.pointZone.id);
      if (view) view.displayCollision(e.data.bubble);
    },
  };

  private readonly textPool: PoolGroup<PIXI.Text> = new PoolGroup(
    () => {
      const text = new PIXI.Text("", {
        fontSize: 28,
        fontFamily: 'Futura-Bold',
        fill: 'white',
      });
      text.anchor.set(0.5);
      return text;
    },
    (element) => {
      element.position.set(0);
      element.alpha = 1;
    },
    (element) => element.destroy(),
  );

  private readonly model: IPopOutSpaceData;
  private readonly idToView: Map<string, PointZoneView> = new Map();

  constructor(
    model: IPopOutSpaceData,
    tweenManager: TweenManager,
  ) {
    super();
    this.model = model;

    model.pointZones.forEach((zone: IPointZone) => {
      const view = new PointZoneView(zone, this.textPool, tweenManager);
      this.addChild(view);
      this.idToView.set(zone.id, view);
    });
  }

  public resize(model: IPopOutSpaceData, pixelSize: IHexPixelSize): void {
    model.pointZones.forEach((zone: IPointZone) => {
      this.idToView.get(zone.id)?.resize(zone, pixelSize);
    });
  }

  private handleBubbleUpdate(event: IEvent<EventType.BubbleUpdated>): void {
    this.idToView.forEach((pointZone) => {
      pointZone.handleBubbleUpdate((event as IEvent<EventType.BubbleUpdated>).data.bubble);
    });
  }

  private handlePointZoneCollision(event: IEvent<EventType.BubblePointZoneCollision>): void {
    const view = this.idToView.get(event.data.pointZone.id);
    view && view.displayCollision(event.data.bubble);
  }
}